var map = {
	"./C000030.png": "b4e0",
	"./C000040.png": "4e98",
	"./Coin.png": "fd24",
	"./Energy.png": "3eab",
	"./H000010_sprout.png": "7c8a",
	"./H000020_mushroom.png": "2a71",
	"./H000030_popcandy.png": "1e29",
	"./H000040_paperplane.png": "56df",
	"./H000050_pencil.png": "8624",
	"./H000060_flower.png": "262f",
	"./H000070_windmill.png": "04c3",
	"./H000080_blackcap.png": "226c",
	"./H000090_fishhead.png": "14a8",
	"./H000100_fishtail.png": "4d41",
	"./H000110_fishred.png": "7d39",
	"./H000120_rottoenapple.png": "5b55",
	"./H000130_applegreen.png": "5f4c",
	"./H000140_apple.png": "0701",
	"./H000150_goldenapple.png": "5c4b",
	"./H000160_bluewhale.png": "605e",
	"./H000170_crab.png": "7192",
	"./H000180_starfish.png": "9c05",
	"./LuckyEgg.png": "c312"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "267e";